// @ts-nocheck
import { removeCookie, setCookie } from "@insite/client-framework/Common/Cookies";
import useIsomorphicLayoutEffect from "@toolkit/Framework/Common/Hooks/useIsomorphicLayoutEffect";
import Cookies from "js-cookie";

export const useHandleSetCookie = (name: string, value: string, options?: Cookies.CookieAttributes) => {
    useIsomorphicLayoutEffect(() => {
        setCookie(name, value, options);
    }, []);
};

export const useHandleRemoveCookie = (name: string, options?: Cookies.CookieAttributes) => {
    useIsomorphicLayoutEffect(() => {
        removeCookie(name, options);
    }, []);
};
